import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.service-areas')
  .factory('$serviceArea', ServiceAreaObjectFactory);

/* @ngInject */
function ServiceAreaObjectFactory($bringozFactory: $bringozFactory,
                                  ServiceAreasAPI: BringozApi,
                                  ServiceArea_DS: DataStoreConfig) {

  function $serviceArea(id: string) {
    return $bringozFactory(id, ServiceAreasAPI, ServiceArea_DS);
  }

  return $serviceArea;
}
